import { ofType } from "redux-observable";
import { EMPTY } from "rxjs";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { EventType } from "../../../balancing/types/BalancingCore";
import { TypeActionEventInfo } from "../../event/actionEventInfo";
import { actionPlayerLeagueInfo } from "../actionPlayerLeagueInfo";
export var epicPlayerLeagueInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionEventInfo.Received), switchMap(function (action) {
        if (!action.eventInfo ||
            !action.eventInfo.leagueEvent ||
            !action.eventInfo.leagueEvent[0]) {
            return EMPTY;
        }
        return deps.netSend({
            id: CommandCode.PlayerLeagueInfo,
            props: {
                eventId: action.eventInfo.leagueEvent[0].eventId,
                playerId: state$.value.playerInfo.playerId,
            },
        });
    }), retry(), map(function (res) { return actionPlayerLeagueInfo(res, EventType.PlayerLeague); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/league/epics/epicPlayerLeagueInfo.ts
// module id = 1913
// module chunks = 3